<template>
  <div>
    <CreateCard />
    <AccountListCard />
  </div>
</template>
<script>
import AccountListCard from "@/components/LegalEntityManage/AccountListCard.vue";
import CreateCard from "@/components/LegalEntityManage/CreateCard.vue";

export default {
  components: { AccountListCard, CreateCard }
};
</script>
